import * as buttons from 'smg/buttons';
import * as contact from 'smg/customer-api/contact';
import { Session } from 'smg/customer-api/session';
import * as enhancedconversions from 'smg/enhanced-conversions';
import { Phone } from 'smg/phone';
import QueryString from 'smg/querystring';
import * as uploads from 'smg/uploads';
import { GetFirstAndLast } from 'smg/users';
import { Relref } from '../hugo';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
}
declare const window: myWindow;

void main();

async function main() {
    const fullName = document.querySelector('#full-name') as HTMLInputElement;
    const company = document.querySelector('#company') as HTMLInputElement;
    const email = document.querySelector('#email') as HTMLInputElement;
    const notes = document.querySelector('#notes') as HTMLTextAreaElement;
    const phone = document.querySelector('#phone') as HTMLInputElement;
    const preferSMS = document.querySelector<HTMLInputElement>('#sms-opt-in');
    const form = document.querySelector('#form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const header = document.querySelector('h1') as HTMLElement;
    const uploadsLabel = form.querySelector('#uploads') as HTMLLabelElement;
    const orderContext = document.querySelector('#order-context') as HTMLElement;

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    // The Signature "Delivered" email's "Not so awesome" link carries the order
    // it's about, so an unhappy customer never has to retype it (#7044).
    const invoiceNumber = Number(QueryString().get('invoice'));
    const orderReference = invoiceNumber > 0 ? `Regarding order #${invoiceNumber}` : '';
    if (orderReference) {
        orderContext.textContent = orderReference;
        orderContext.classList.remove('d-none');
    }

    const p = new Phone(phone);

    try {
        const user = await Session().then(s => s.user);
        fullName.value = user.fullName();
        email.value = user.emailAddress.email;
        void p.ready().then(() =>
            p.iti.setNumber(user.phoneNumber.phone));
        company.value = user.company ?? '';
    } catch (err) {
        console.error(err);
    }

    const showAlert = (type: 'generic' = 'generic') => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector(`.${type}`);
        msg?.classList.remove('d-none');

        header.after(a);
    };

    const hideAlert = () => {
        const a = form.querySelector('.alert');
        a?.parentElement?.removeChild(a);
    };

    const u = new uploads.Uploader(uploadsLabel, {
        confirmBtn: confirm,
        thumbnails: document.querySelector('#uploads-thumbnails') as HTMLElement,
    });

    form?.addEventListener('submit', e => {
        e.preventDefault();

        hideAlert();
        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);
        contact.CreateContact({
            name: fullName.value,
            company: company.value,
            phone: p,
            email: email.value,
            preferSMS: preferSMS?.checked,
            content: orderReference ? `${orderReference}:\n\n${notes.value}` : notes.value,
            uploader: u,
            $reCaptchaPlaceholder: form.querySelector('.contact-recpatcha-parent') as HTMLElement,
        }).then(async () => {
            const user = await Session().then(s => s.user).catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            const { firstName, lastName } = GetFirstAndLast(String(fullName.value));
            // The event carries the module's gated view so bare names without
            // a complete address never reach Google (#9198 class 3).
            const userData = enhancedconversions.Set({
                email: user?.emailAddress.email || email.value,
                phone: user?.phoneNumber.phone || await p.format(),
                firstName: user?.firstName || firstName,
                lastName: user?.lastName || lastName,
            });
            dataLayer.push({
                'event': 'hugo-contact-submit',
                'userData': { ...userData },
            });

            window.location.href = Relref('/contact/success');
        }).catch(err => {
            console.error(err);
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);

            if (err !== contact.ReCaptchaError) {
                showAlert();
            }
        });
    });
}